import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Logo from "../components/Logo";
import SocialAuthButtons from "../components/SocialAuthButtons";
import { LOGO_AUTH_DEFAULT } from "../config/logoSizes";
const EyeIcon = ({ open }) => open ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg> : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>;
const SignUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.setItem("taweelai_theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
    document.documentElement.style.colorScheme = "light";
  }, []);
  const [form, setForm] = useState({ name: "", email: "", password: "", confirmPassword: "" });
  const [showPw, setShowPw] = useState(false);
  const [showCpw, setShowCpw] = useState(false);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = t("nameRequired");
    if (!form.email) e.email = t("emailRequired");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = t("emailInvalid");
    if (!form.password) e.password = t("passwordRequired");
    else if (form.password.length < 8) e.password = t("passwordMin");
    else if (!/[A-Z]/.test(form.password)) e.password = t("passwordUpper");
    else if (!/[0-9]/.test(form.password)) e.password = t("passwordNumber");
    if (form.password !== form.confirmPassword) e.confirmPassword = t("passwordsMatch");
    return e;
  };
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setErrors({});
    setLoading(true);
    try {
      const { data } = await axios.post("/api/auth/signup", form);
      const em = data?.email || form.email;
      sessionStorage.setItem("pendingEmail", em);
      navigate("/verify-email", { state: { email: em } });
    } catch (err) {
      const d = err.response?.data;
      if (d?.redirect === "/verify-email") {
        const em = (d.email || form.email || "").trim();
        if (em) {
          sessionStorage.setItem("pendingEmail", em);
          navigate("/verify-email", {
            replace: false,
            state: { email: em, signupNote: d.message }
          });
          return;
        }
      }
      setAlert({ type: "error", msg: d?.message || t("error") });
    } finally {
      setLoading(false);
    }
  };
  return <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-card auth-card--session auth-card--signup">
        <div className="auth-logo-area" onClick={() => navigate("/chat")} style={{ cursor: "pointer" }}>
          <Logo variant="full" size={LOGO_AUTH_DEFAULT} className="auth-logo-img" />
        </div>
        <p className="auth-title">{t("createAccount")}</p>
        <SocialAuthButtons onError={setAlert} onLoadingChange={setLoading} />
        <div className="divider">{t("orContinueWith")}</div>
        {alert && <div className={`form-alert ${alert.type}`}>{alert.msg}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">{t("name")}</label>
            <input
    className={`form-input ${errors.name ? "err" : ""}`}
    type="text"
    placeholder={t("namePlaceholder")}
    value={form.name}
    onChange={(e) => setForm({ ...form, name: e.target.value })}
  />
            {errors.name && <div className="form-err">⚠ {errors.name}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">{t("email")}</label>
            <input
    className={`form-input ${errors.email ? "err" : ""}`}
    type="email"
    placeholder="you@example.com"
    value={form.email}
    onChange={(e) => setForm({ ...form, email: e.target.value })}
  />
            {errors.email && <div className="form-err">⚠ {errors.email}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">{t("password")}</label>
            <div className="input-wrap-pw">
              <input
    className={`form-input with-eye ${errors.password ? "err" : ""}`}
    type={showPw ? "text" : "password"}
    placeholder="Min 8 chars, 1 uppercase, 1 number"
    value={form.password}
    onChange={(e) => setForm({ ...form, password: e.target.value })}
  />
              <button type="button" className="eye-btn" onClick={() => setShowPw(!showPw)}>
                <EyeIcon open={showPw} />
              </button>
            </div>
            {errors.password && <div className="form-err">⚠ {errors.password}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">{t("confirmPassword")}</label>
            <div className="input-wrap-pw">
              <input
    className={`form-input with-eye ${errors.confirmPassword ? "err" : ""}`}
    type={showCpw ? "text" : "password"}
    placeholder={t("confirmPasswordPlaceholder")}
    value={form.confirmPassword}
    onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
  />
              <button type="button" className="eye-btn" onClick={() => setShowCpw(!showCpw)}>
                <EyeIcon open={showCpw} />
              </button>
            </div>
            {errors.confirmPassword && <div className="form-err">⚠ {errors.confirmPassword}</div>}
          </div>
          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? <><div className="spinner" /> {t("creatingAccount")}</> : t("createAccount")}
          </button>
        </form>
        <div className="auth-foot">{t("hasAccount")} <Link to="/signin">{t("signIn")}</Link></div>
      </div>
    </div>;
};
var stdin_default = SignUp;
export {
  stdin_default as default
};
